<template>
  <div :class="theme" class="section-header row justify-content-between">
    <div
      v-if="
        blok.header_link && blok.header_link[0] && blok.header_link[0].component
      "
      class="section-header__link col-12"
    >
      <component
        :is="blok.header_link[0].component | dashify"
        :blok="blok.header_link[0]"
        modifier-class="icon icon--arrow"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    theme: {
      type: String,
      default: 'theme-gray-light',
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.section-header {
  &__title {
    p {
      @include font-size(18, rem-v(24));

      margin: 0;
    }

    small {
      @include font-size(18, rem-v(24));

      display: inline-block;
    }
  }

  &__link {
    text-align: right;

    a {
      &::before {
        font-size: 12px;
        margin-right: 10px;
      }
    }
  }
}
</style>
